const initialState = {
  users: [],
  teams: [],
  updates: [],
  posts: [],
  products: [],
  games: [],
  shoutouts: [],
  fancams: [],
  tiriItems: []
};

const admin = (state = null, action) => {
  const { payload, type } = action;

  let ids;
  switch (type) {
    case 'SET_ADMIN':
      return payload;

    case 'ADMIN_SET_USERS':
      return {
        ...state,
        users: payload
      };

    case 'ADMIN_ADD_USERS':
      ids = [...payload.map((x) => x._id)];

      return {
        ...state,
        users: [...(state.users?.filter((x) => !ids.includes(x._id)) || []), ...payload]
      };

    case 'ADMIN_ADD_USER':
      return {
        ...state,
        users: [payload, ...state.users.filter((x) => x._id !== payload._id)]
      };

    case 'ADMIN_EDIT_USER':
      return {
        ...state,
        users: state.users.map((x) => {
          if (x._id !== payload._id) return x;

          return {
            ...x,
            ...payload
          };
        })
      };

    case 'ADMIN_VERIFY_USER':
      return {
        ...state,
        users: state.users.map((x) => {
          if (x._id !== payload.userId) return x;

          return {
            ...x,
            verified: {
              ...x.verified,
              idProgress: payload.status,
              id: payload.status === 'verified',
              email: payload.status === 'verified' ? true : x.verified.email
            }
          };
        })
      };

    case 'ADMIN_SET_TEAMS':
      return {
        ...state,
        teams: payload
      };

    case 'ADMIN_ADD_TEAMS':
      ids = [...payload.map((x) => x._id)];

      return {
        ...state,
        teams: [...(state.teams?.filter((x) => !ids.includes(x._id)) || []), ...payload]
      };

    case 'ADMIN_ADD_TEAM':
      return {
        ...state,
        teams: [payload, ...state.teams.filter((x) => x._id !== payload._id)]
      };

    case 'ADMIN_EDIT_TEAM':
      return {
        ...state,
        teams: state.teams.map((x) => {
          if (x._id !== payload._id) return x;

          return {
            ...x,
            ...payload
          };
        })
      };

    case 'ADMIN_UPDATE_EVENT':
      return {
        ...state,
        updates: [payload, ...state.updates.filter((x) => x._id !== payload._id)]
      };

    case 'ADMIN_SET_POSTS':
      return {
        ...state,
        posts: payload
      };

    case 'ADMIN_ADD_POST':
      return {
        ...state,
        posts: [payload, ...state.posts.filter((x) => x._id !== payload._id)]
      };

    case 'ADMIN_ADD_POSTS':
      return {
        ...state,
        posts: [...state.posts, ...payload]
      };

    case 'ADMIN_SET_STORIES':
      return {
        ...state,
        stories: payload
      };

    case 'ADMIN_ADD_STORY':
      return {
        ...state,
        stories: [payload, ...state.stories.filter((x) => x._id !== payload._id)]
      };

    case 'ADMIN_REMOVE_STORY':
      return {
        ...state,
        stories: state.stories.filter((x) => x._id !== payload._id)
      };

    case 'ADMIN_ADD_STORIES':
      return {
        ...state,
        stories: [...state.stories, ...payload]
      };

    case 'ADMIN_EDIT_POST':
      return {
        ...state,
        posts: state.posts.map((x) => {
          if (x._id !== payload._id) return x;

          return { ...x, ...payload };
        })
      };

    case 'ADMIN_ADD_REPORTS':
      return {
        ...state,
        reports: [...state.reports, ...payload]
      };

    case 'ADMIN_SET_REPORTS':
      return {
        ...state,
        reports: payload
      };

    case 'ADMIN_EDIT_REPORT':
      return {
        ...state,
        reports: state.reports.map((x) => {
          if (x._id !== payload._id) return x;

          return {
            ...x,
            ...payload
          };
        })
      };

    case 'ADMIN_SET_PRODUCTS':
      return {
        ...state,
        products: payload
      };

    case 'ADMIN_ADD_PRODUCT':
      return {
        ...state,
        products: [payload, ...state.products]
      };

    case 'ADMIN_ADD_ORDER':
      return {
        ...state,
        orders: [payload, ...state.orders]
      };

    case 'ADMIN_ADD_ORDERS':
      return {
        ...state,
        orders: [...state.orders, ...payload]
      };

    case 'ADMIN_SET_ORDERS':
      return {
        ...state,
        orders: payload
      };

    case 'ADMIN_EDIT_ORDER':
      return {
        ...state,
        orders: state.orders.map((x) => {
          if (x._id !== payload._id) return x;

          return {
            ...x,
            ...payload
          };
        })
      };

    case 'ADMIN_SET_GAMES':
      return {
        ...state,
        games: payload
      };

    case 'ADMIN_ADD_GAMES':
      return {
        ...state,
        games: [...(state.games || []), ...payload]
      };

    case 'ADMIN_UPDATE_GAME':
      return {
        ...state,
        games: state.games.map((x) => {
          if (x._id !== payload.gameId) return x;

          return { ...x, ...payload };
        })
      };

    case 'UPDATE_GAMES':
      if (!state || !state?.games?.length) return state;

      return {
        ...state,
        games: state.games.map((x) => {
          const updatedGame = payload.find((y) => y._id === x._id);
          if (!updatedGame) return x;

          return {
            ...x,
            ...updatedGame
          };
        })
      };

    case 'ADMIN_ADD_PRODUCTS':
      return {
        ...state,
        products: [...state.products, ...payload]
      };

    case 'ADMIN_REMOVE_DATA':
      return {
        users: state.users?.filter((x) => x._id !== payload),
        teams: state.teams?.filter((x) => x._id !== payload),
        updates: state.updates?.filter((x) => x._id !== payload),
        posts: state.posts?.filter((x) => x._id !== payload),
        products: state.products?.filter((x) => x._id !== payload),
        stories: state.stories?.filter((x) => x._id !== payload),
        reports: state.reports?.map((x) => {
          const content =
            x?.post ||
            x?.story ||
            x?.shoutout ||
            x?.fancam ||
            x?.comment ||
            x?.fanchat ||
            x?.fanchatTopic ||
            x?.fanchatMessage;
          if (!content || content?._id !== payload) return x;

          return {
            ...x,
            status: 'contentRemoved'
          };
        }),
        games: state.games?.filter((x) => x._id !== payload)
      };

    case 'ADMIN_REMOVE_SHOUTOUT':
      return {
        ...state,
        shoutouts: state.shoutouts?.filter((x) => x._id !== payload)
      };

    case 'ADMIN_SET_ATHLETE_TIERS':
      return {
        ...state,
        athleteTiers: payload
      };

    case 'ADMIN_ADD_ATHLETE_TIERS':
      return {
        ...state,
        athleteTiers: [...state.athleteTiers, ...payload]
      };

    case 'ADMIN_ADD_ATHLETE_TIER':
      return {
        ...state,
        athleteTiers: [payload, ...state.athleteTiers.filter((x) => x._id !== payload._id)]
      };

    case 'ADMIN_EDIT_ATHLETE_TIER':
      return {
        ...state,
        athleteTiers: state.athleteTiers.map((x) => {
          if (x._id !== payload._id) return x;

          return { ...x, ...payload };
        })
      };

    case 'ADMIN_SET_FANCAMS':
      return {
        ...state,
        fancams: payload
      };

    // Drops any row the incoming page repeats, the way ADMIN_ADD_USERS does. A blind append
    // let an overlapping fetch put the same fancam on screen twice.
    case 'ADMIN_ADD_FANCAMS':
      ids = [...payload.map((x) => x._id)];

      return {
        ...state,
        fancams: [...(state.fancams?.filter((x) => !ids.includes(x._id)) || []), ...payload]
      };

    case 'ADMIN_REMOVE_FANCAM':
      return {
        ...state,
        fancams: state.fancams?.filter((x) => x._id !== payload)
      };

    case 'ADMIN_SET_TIRI':
      return {
        ...state,
        tiriItems: payload
      };

    // Deduped on append for the same reason as ADMIN_ADD_FANCAMS: an overlapping fetch would
    // otherwise put the same TIRI item on screen twice.
    //
    // A Set rather than the array + `includes` the other cases use: this list pages without an
    // upper bound, so `includes` inside the filter made every append cost page size x rows so
    // far. Own block scope because the id lookup is a Set here, not the shared `ids` array.
    case 'ADMIN_ADD_TIRI': {
      const incoming = new Set(payload.map((x) => x._id));

      return {
        ...state,
        tiriItems: [...(state.tiriItems?.filter((x) => !incoming.has(x._id)) || []), ...payload]
      };
    }

    // Patches the one labeled row in place rather than refetching the page, so the admin's
    // scroll position and the rest of the list survive a save.
    case 'ADMIN_EDIT_TIRI':
      return {
        ...state,
        tiriItems: state.tiriItems?.map((x) =>
          x._id !== payload._id
            ? x
            : {
                ...x,
                // The label endpoint answers with a flat action result — it is not a Tiri
                // document — while the row keeps each module's state under its own key. This
                // is the one place that bridges the two, so no component has to.
                tagit: {
                  ...x.tagit,
                  category: payload.category ?? x.tagit?.category,
                  categoryStatus: payload.categoryStatus ?? x.tagit?.categoryStatus,
                  isPoolEligible: payload.isPoolEligible ?? x.tagit?.isPoolEligible
                }
              }
        )
      };

    case 'ADMIN_SET_SHOUTOUTS':
      return {
        ...state,
        shoutouts: payload
      };

    case 'ADMIN_ADD_SHOUTOUTS':
      return {
        ...state,
        shoutouts: [...state.shoutouts, ...payload]
      };

    case 'ADMIN_SET_TIER_ASSIGNMENTS':
      return {
        ...state,
        tierAssignments: payload
      };

    case 'ADMIN_SET_TEAM_COUNT':
      return {
        ...state,
        teamCount: payload
      };

    case 'ADMIN_ADD_TIER_ASSIGNMENTS':
      return {
        ...state,
        tierAssignments: [...state.tierAssignments, ...payload]
      };

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default admin;
